/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { StorageModule } from '@vlinder-web/storage-module-react';

import { INVITE_EMPLOYEE } from '../../api/graphql';
import moment from 'moment-timezone';
import { vappContainer } from '@/application';
import { Graphql } from '@common/graphql';
import { AppNavigatorService } from '@/AppNavigator/services';
import { apiConfig } from '@/config/apiConfig';
import { toast } from 'react-hot-toast';
import { getErrorMessage } from '@/utils/error.message';

const getStorageSrv = StorageModule?.getInstance();

const loginSrv = () => {
  return vappContainer.get<AppNavigatorService>(
    AppNavigatorService.displayName
  );
};

export interface InviteUserProps {
  userEmail: string;
  firstName: string;
  lastName: string;
  invite: boolean;
  userRoles: boolean;
  loginRestAPI: string;
  headers: any;
  sendInvite: any;
}
export interface IInviteUserMethods extends IPluginMethodMap {
  getInviteUser(args: InviteUserProps): Promise<any>;
}

export class InviteUserService implements IAgentPlugin {
  readonly methods: IInviteUserMethods;

  constructor() {
    this.methods = {
      getInviteUser: this.getInviteUser.bind(this),
    };
  }

  async getInviteUser(args: InviteUserProps) {
    console.log(`args in invite user service`, args);
    try {
      let gql = Graphql.withBaseUrl(apiConfig.gql.url);
      const token = loginSrv()?.getToken();
      if (token) {
        gql = gql.withHeaders({
          authentication: token,
        });
      }
      const client = gql.getClient();
      if (client) {
        const res = await client.mutation(INVITE_EMPLOYEE, {
          input: {
            invite: args?.invite ?? false,
            user: {
              firstName: args?.firstName,
              lastName: args?.lastName,
              email: args?.userEmail,
            },
            // org: this.getOrgnizationId(),
            // role: await this.getRole(args?.userRoles),
          },
        });
        console.log(
          'hi->',
          res,
          res?.error,
          res?.error?.graphQLErrors,
          !!res?.data?.createUser
        );
        if (res?.error) {
          getErrorMessage(res?.error);
          return null;
        } else if (!!res?.data?.createUser) {
          console.log(`table data`, res);
          return {
            ...res?.data?.createUser,
          };
        }
      }
    } catch (err: any) {
      //getErrorMessage(err);
      throw err;
    }
  }

  private getOrgnizationId() {
    let orgId = getStorageSrv?.get('myProfile', 'session')?.org?.orgId;
    return orgId;
  }

  private async getRole(roles: any) {
    console.log(`roles:`, roles);
    let adminRole =
      Array.isArray(roles) && roles?.find((item) => item?.name === 'admin');
    console.log(`admin Role`, adminRole);
    return adminRole?.uuid;
    // const user = await getWhoamiSrv()?.whoAmI();
    // if(user?.whoami === "RISK_CAPITAL"){
    //   return null
    // }
    // else{
    //   return null
    // }
  }
}
